import { computed, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { masifiWhatsappProviders } from 'dashboard/helper/masifi/masifiWhatsappProviders';
import { WHATSAPP_QR_PROVIDER } from 'dashboard/helper/masifi/masifiWhatsappQr';

// channels/Whatsapp.vue (upstream) hook. One call gives what the upstream file needs, so it adds one line per use:
// - providers: the upstream cards post-processed with the account's entitlements (QR card, Twilio visibility);
// - isQr(provider): the check for the v-else-if that renders our creation form.
// reactive() so the template reads masifiWa.providers without .value.
export const useMasifiWhatsappProviders = availableProviders => {
  const { t } = useI18n();
  const { isCloudFeatureEnabled } = useAccount();

  return reactive({
    providers: computed(() =>
      masifiWhatsappProviders(availableProviders.value, {
        t,
        isCloudFeatureEnabled,
      })
    ),
    isQr: provider => provider === WHATSAPP_QR_PROVIDER,
  });
};
